/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'company-hub.search-extension.custom-search-config-panel.corner-style-label': 'Esquinas',
  'company-hub.search-extension.custom-search-config-panel.default-placeholder-text':
    'Busca anuncios, recursos y políticas verificados',
  'company-hub.search-extension.custom-search-config-panel.filters-title': 'Filtros',
  'company-hub.search-extension.custom-search-config-panel.placeholder-text-label': 'Texto de marcador de posición',
  'company-hub.search-extension.custom-search-config-panel.placeholder-tooltip-label':
    'Personaliza el mensaje que verán los lectores',
  'company-hub.search-extension.custom-search-config-panel.preamble': 'Añade una barra de búsqueda filtrada',
  'company-hub.search-extension.custom-search-config-panel.round-corner-style-label': 'Redondo',
  'company-hub.search-extension.custom-search-config-panel.sharp-corner-style-label': 'Cuadrado',
  'company-hub.search-extension.custom-search-config-panel.styles-fill-color-label': 'Color de relleno',
  'company-hub.search-extension.custom-search-config-panel.styles-text-color-label': 'Color del texto',
  'company-hub.search-extension.custom-search-config-panel.styles-title': 'Estilos',
  'company-hub.search-extension.custom-search-config-panel.title': 'Búsqueda personalizada',
  'company-hub.search-extension.manifest.default-placeholder-text': 'Busca anuncios, recursos y políticas verificados',
  'company-hub.search-extension.manifest.macro-description': 'Añade una barra de búsqueda filtrada',
  'company-hub.search-extension.manifest.macro-title': 'Búsqueda personalizada',
  'company-hub.search-extension.more-button': 'Ver más resultados',
};
